const initialState = {
    billingsListResponse: [],
    billingsByIdResponse: [],
    billingsEditResponse: [],
    responseHashExportBillings: [],
    responseCheckReportBilling: [],
    errorBillingsList: false,
    errorBillingsById: false,
    errorBillingsEdit: false,
    errorHashExportBillings: false,
    errorCheckReportOffices: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "GET_RESPONSE_BILLINGS_LIST":
            newState.billingsListResponse = action.value;
            if (action.value === undefined) {
                newState.errorBillingsList = true;
            } else {
                newState.errorBillingsList = false;
            }
            break;
        case "GET_BILLING_BY_ID":
            newState.billingsByIdResponse = action.value;
            if (action.value === undefined) {
                newState.errorBillingsById = true;
            } else {
                newState.errorBillingsById = false;
            }
            break;
        case "BILLING_EDIT_RESPONSE":
            newState.billingsEditResponse = action.value;
            if (action.value === undefined) {
                newState.errorBillingsEdit = true;
            } else {
                newState.errorBillingsEdit = false;
            }
            break;
        case 'HASH_EXPORT_BILLING_RESPONSE':
            newState.responseHashExportBillings = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportBillings = true;
            } else {
                newState.errorHashExportBillings = false;
            }
            break;
        case 'REPORT_EXPORT_BILLING_RESPONSE':
            newState.responseCheckReportBilling = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportOffices = true;
            } else {
                newState.errorCheckReportOffices = false;
            }
            break;
        default:
            return newState;
    }
    return newState;
};

export default reducer;